'use strict';

/**
 * FilterableTable
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.FilterableTable = T.createModule({

	_selectors: {
		table: '[data-js-m-filterable-table__table]',
		headerRow: 'thead [data-js-m-filterable-table__row] th',
		row: 'tbody [data-js-m-filterable-table__row]',
		cell: 'td',
		input: '[data-js-m-filter-dropdown__input]',
		template: '[data-js-filterable-table__template]'
	},

	_stateClasses: {
		filtered: 'm-filterable-table--filtered'
	},

	_eventNames: {
		filterChange: 'm-filterable-table__filter-change'
	},

	filters: {},

	start: function start(resolve) {
		var _this = this;

		this.$ctx = $(this._ctx);
		this.$headers = this.$ctx.find(this._selectors.headerRow);
		this.$rows = this.$ctx.find(this._selectors.row);
		this.$template = this.$ctx.find(this._selectors.template);

		this._events.on(this._eventNames.filterChange, function (columnIndex, value) {
			return _this.filterRows(columnIndex, value);
		});

		this.generateFiltersFromTemplate();

		resolve();
	},


	/**
  * Dynamically creates the filters depending on table content.
  *
  * @returns {undefined} void
  **/
	generateFiltersFromTemplate: function generateFiltersFromTemplate() {
		var template = doT.template(this.$template.html());
		this.$ctx.prepend(template(this.getColumns()));
		this.initializeTerrificForNewFilters();
	},


	/**
  * Generates the columns to generate the template from the table values.
  *
  * @returns {Object} Object containing all columns with cell values and unique options
  **/
	getColumns: function getColumns() {
		var _this2 = this;

		var columns = [];

		this.$headers.each(function (element, index) {
			columns.push(_this2.createFilter(element, index));
		});

		return {
			columns: this.findUniqueCellValues(columns)
		};
	},


	/**
  * Initializes the filter depending on the table content.
  *
  * @param {number} rowIndex The row index
  * @param {node} element The element
  * @returns {Object} The column object
  **/
	createFilter: function createFilter(rowIndex, element) {
		var _this3 = this;

		var $element = $(element);
		var label = $element.text();
		var column = {
			index: rowIndex,
			id: rowIndex,
			label: label,
			cells: []
		};

		this.$rows.each(function (cellIndex, rowElement) {
			var $row = $(rowElement);
			var $cells = $row.find(_this3._selectors.cell);
			var cell = $cells.get(rowIndex);
			var cellText = $(cell).text();

			column.cells.push(cellText);
		});

		return column;
	},


	/**
  * Finds the unique values for the cells.
  *
  * @param {Array} columns The columns
  * @returns {Array} The unique cell values
  **/
	findUniqueCellValues: function findUniqueCellValues(columns) {
		return columns.map(function (column) {
			column.options = column.cells.filter(function (v, i, a) {
				return a.indexOf(v) === i;
			});
			return column;
		});
	},


	/**
  * The filter need a plugin, so we have to dynamically add them to terrific later on.
  *
  * @returns {undefined} void
  **/
	initializeTerrificForNewFilters: function initializeTerrificForNewFilters() {
		this._sandbox.addModules(this.$ctx.children().first().get(0));
	},


	/**
  * Filters the displayed rows based on the new filters.
  *
  * @param {number} columnIndex The column index
  * @param {string} value The value
  * @returns {undefined} void
  **/
	filterRows: function filterRows(columnIndex, value) {
		var _this4 = this;

		if (!value || value === '') {
			delete this.filters[columnIndex];
		} else {
			this.filters[columnIndex] = value;
		}

		this.toggleTableFilteredState();

		this.$rows.each(function (cellIndex, element) {
			return _this4.showOrHideRow(cellIndex, element);
		});
	},


	/**
  * When there are more than 50 entries the table will only be shown
  * if at least one filter has been selected.
  *
  * @returns {undefined} void
  **/
	toggleTableFilteredState: function toggleTableFilteredState() {
		if (Object.keys(this.filters).length) {
			this.$ctx.addClass(this._stateClasses.filtered);
		} else {
			this.$ctx.removeClass(this._stateClasses.filtered);
		}
	},


	/**
  * Depending on the filters the row is shown or hidden.
  *
  * @param {number} cellIndex The cell index
  * @param {node} element The element
  * @returns {undefined} void
  **/
	showOrHideRow: function showOrHideRow(cellIndex, element) {
		var _this5 = this;

		var $row = $(element);
		var $cells = $row.children();
		var keys = Object.keys(this.filters);
		var hide = false;

		keys.forEach(function (key) {
			var content = $($cells.get(key)).text();

			if (content !== _this5.filters[key]) {
				hide = true;
			}
		});

		if (hide) {
			$row.hide();
		} else {
			$row.show();
		}
	}
});